var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfaSolidPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.645,
    height: 107.244,
    viewBox: "0 0 112.645 107.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-paper-plane",
    "data-name": "Icon fa-solid-paper-plane",
    d: "M109.59,1.173a6.567,6.567,0,0,1,2.97,6.534L98.479,94.825a6.7,6.7,0,0,1-3.52,4.817,7.37,7.37,0,0,1-6.16.335L62.485,89.568,47.414,105.086a7.287,7.287,0,0,1-7.744,1.7,6.719,6.719,0,0,1-4.466-6.262V83.014a3.194,3.194,0,0,1,.924-2.241L73,42.47a3.212,3.212,0,0,0-.088-4.607,3.649,3.649,0,0,0-4.84-.147L23.323,75.558,3.9,66.3a6.552,6.552,0,0,1-.352-11.811L102.109.88a7.365,7.365,0,0,1,7.48.293Z",
    transform: "translate(0.001 0)",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfaSolidPaperPlane);
export default __webpack_public_path__ + "static/media/Icon fa-solid-paper-plane.2ddfbe30506b0f8c3fa8994e88837d6d.svg";
export { ForwardRef as ReactComponent };